/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Map
 */

'use strict';

module.exports = require('core-js/library/es6/map');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/fbjs/lib/Map.js
 ** module id = 163
 ** module chunks = 0
 **/